import React from 'react'
import styled from 'styled-components'
import {GIFT_SHOP_NOT_LINK_BASED_SOCIAL_MEDIA} from 'consts'
import {getTextShadow, transformSocialType} from 'utils'
import {Paragraph} from 'common/components'
import {ProfileDetailSocialLinkItemProps} from './TemplateProfileDetailItemProps'

const StyledSocialSpan = styled.span`
  color: ${({theme}) => theme.info_3};
  cursor: pointer;
`

const StyledParagraph = styled(Paragraph)`
  text-shadow: ${({theme}) => getTextShadow(theme, {opacity: 0.5})};
`

export default function ProfileDetailSocialLinkItem({
  item,
  onClickItem,
}: ProfileDetailSocialLinkItemProps) {
  return (
    <StyledParagraph fontSize="m" fontWeight="bold" color="white_1">
      {transformSocialType(item.social_type)}:{' '}
      <StyledSocialSpan onClick={() => onClickItem(item)}>
        {GIFT_SHOP_NOT_LINK_BASED_SOCIAL_MEDIA.includes(item.social_type)
          ? item.social_value.substring(item.social_value.lastIndexOf('/') + 1)
          : item.social_value}
      </StyledSocialSpan>
    </StyledParagraph>
  )
}
